"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHeatmapUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketHelper_1 = require("../bucketHelper");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/heatmap/bucket-title-measures.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/heatmap/bucket-title-view.svg"));
var bucket_title_stack_svg_1 = tslib_1.__importDefault(require("../../assets/heatmap/bucket-title-stack.svg"));
function setHeatmapUiConfig(referencePoint, intl, visualizationType) {
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG], bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], bucket_title_view_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "icon"], bucket_title_stack_svg_1.default);
    return referencePointConfigured;
}
exports.setHeatmapUiConfig = setHeatmapUiConfig;
//# sourceMappingURL=heatmapUiConfigHelper.js.map